import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export type StatusType = 'active' | 'expired' | 'expires-soon' | 'na';

@Component({
  selector: 'grid-ui-cell-renderer-pills',
  standalone: false,
  templateUrl: './cell-renderer-pills.component.html',
  styleUrl: './cell-renderer-pills.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CellRendererPillsComponent implements ICellRendererAngularComp {
  private readonly defaultStatusMap: Record<StatusType, string> = {
    active: 'Active',
    expired: 'Expired',
    'expires-soon': 'Expires Soon',
    na: 'N/A',
  };

  public readonly status = signal<StatusType>('na');

  public readonly statusName = computed(() => this.defaultStatusMap[this.status()]);

  public refresh(): boolean {
    return false;
  }

  public agInit(params: ICellRendererParams): void {
    this.status.set(params.data.status ?? 'na');
  }
}
